import { FC } from 'react';

export const CloseModalIconMob: FC<{ onClick?: () => void }> = ({ onClick }) => (
    <svg className={'close-modal-mobile'} onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.4598 12.0001L2.00016 20.4597L3.53848 21.998L11.9981 13.5384L20.4597 22L21.998 20.4617L13.5364 12.0001L21.9982 3.53831L20.4599 2L11.9981 10.4618L3.53831 2.00195L2 3.54026L10.4598 12.0001Z" fill="#909090"/>
    </svg>
)import { FC } from 'react';

export const CloseModalIconMob: FC<{ onClick?: () => void }> = ({ onClick }) => (
    <svg className={'close-modal-mobile'} onClick={onClick} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M10.4598 12.0001L2.00016 20.4597L3.53848 21.998L11.9981 13.5384L20.4597 22L21.998 20.4617L13.5364 12.0001L21.9982 3.53831L20.4599 2L11.9981 10.4618L3.53831 2.00195L2 3.54026L10.4598 12.0001Z" fill="#909090"/>
    </svg>
)